const e = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="presentation" aria-hidden="true"><path fill-rule="evenodd" d="M7.128 4.966A.75.75 0 0 0 6 5.614v12.772c0 .58.628.94 1.128.648l10.78-6.3a.85.85 0 0 0 0-1.468zM4.5 5.614c0-1.737 1.885-2.82 3.385-1.943l10.78 6.3c1.552.907 1.552 3.15 0 4.058l-10.78 6.3c-1.5.876-3.385-.206-3.385-1.943z" clip-rule="evenodd"/></svg>';
export {
  e as w
};
